<!--
   Created by qing on 2020/8/6
   Des: 
-->
<template>
  <div class="filter-value-container">
    <div class="item-header">
      <div class="field-title">
        {{ field.fieldTitle}}
      </div>
      <div
        class="field-method"
        @click="onClickMethod(filter)">
        {{fetchFilterName(filter.type, filter.method)}}
        <van-icon name="arrow-down"/>
      </div>
      <div
        class="filter-clear"
        @click="deleteCondition()">
        <van-icon name="delete" />
      </div>
    </div>

    <div v-if="filter.method !== FILTER_METHOD_TYPE__EMPTY && filter.method !== FILTER_METHOD_TYPE__NOT_EMPTY">
      <component
        @change="filterChange"
        :field="field"
        :fields="fields"
        :filter-value="filter.value"
        :filter="filter"
        :filter-way="filterWay"
        :dropdown-data="dropdownData"
        :method="filter.method"
        :formId="formId"
        :is="'filter_' + field.type">
      </component>
    </div>

    <!--选择method-->
    <van-dialog
      class="select-method-dialog"
      v-model="methodDialogConfig.visible"
      :show-confirm-button="false"
      close-on-click-overlay
      get-container="body">
      <van-radio-group v-model="methodDialogConfig.method">
        <van-radio
          v-for="method in methodDialogConfig.methodList"
          :key="method.method"
          :name="method.method"
          @click="methodDialogConfig.confirm">
          {{method.name}}
        </van-radio>
      </van-radio-group>
    </van-dialog>
  </div>
</template>

<script>
  import {
    FILTER_METHOD_TYPE__ALL,
    FILTER_METHOD_TYPE__EMPTY, FILTER_METHOD_TYPE__IN, FILTER_METHOD_TYPE__NIN,
    FILTER_METHOD_TYPE__NOT_EMPTY
  } from "./types"
  import FilterValueWidget from './FilterValueWidget/index'
  import {fetchFieldFilterOpts} from "../../../assets/js/Untis"
  import {FORM_ITEM__MEMBER} from "../../RyForm/types";
  export default {
    props: {
      formId: {
        type: String,
        default: ''
      },
      field: {
        type: Object,
        default: () => {}
      },
      fields: {
        type: Array,
        default: () => []
      },
      // 字段类型
      fieldType: {
        type: String,
        default: ''
      },
      // 筛选的 value
      filter: {
        type: Object,
        default: () => {}
        /*
        * {
        * type: '"singleChoose"',
        * method: 'eq',
        * value: [],
        * fieldId: '',
        * fixedValue: ''
        * }
        * */
      },
      // 是否为选择筛选数据，还是手输筛选数据
      filterWay: {
        type: Boolean,
        default: true
      },
      // 是否有删除按钮
      isDelete: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        FILTER_METHOD_TYPE__EMPTY,
        FILTER_METHOD_TYPE__NOT_EMPTY,
        dropdownData: [],

        // 选择method弹框
        methodDialogConfig: {
          visible: false,
          filterCondition: null, // 一个筛选条件对象
          methodList: [],
          method: '',

          open: (condition) => {
            this.methodDialogConfig.filterCondition = condition
            this.methodDialogConfig.methodList = this.actionFetchFieldFilterOpts(condition.type)
            this.methodDialogConfig.method = condition.method
            this.methodDialogConfig.visible = true
          },

          confirm: () => {
            this.methodDialogConfig.filterCondition.method = this.methodDialogConfig.method
            this.methodDialogConfig.filterCondition.fixedValue = 'fixed_value'
            this.methodDialogConfig.filterCondition.value.splice(0, this.methodDialogConfig.filterCondition.value.length)
            this.methodDialogConfig.visible = false
          }
        },
      };
    },
    components: {
      ...FilterValueWidget,
    },
    created() {
    },
    methods: {
      // 用过滤代号获取过滤中文
      fetchFilterName(fieldType) {
        // 取出相应过滤条件，如果有，就拿出method中文名，没有就返回默认第一个
        let filterOpts = this.actionFetchFieldFilterOpts(fieldType)
        if (!this.filter) {
          return filterOpts[0].name
        } else {
          const opt = filterOpts.filter(item => item.method === this.filter.method)[0]
          return opt ? opt.name : filterOpts[0].name
        }
      },
      actionFetchFieldFilterOpts(fieldType) {
        return fetchFieldFilterOpts(fieldType)
      },

      // 选择method
      onClickMethod(item) {
        this.methodDialogConfig.open(item)
      },

      onClickFieldFilterMethod(command) {
        if (this.field.type === FORM_ITEM__MEMBER) {
          if (command.method !== FILTER_METHOD_TYPE__NIN &&
            command.method !== FILTER_METHOD_TYPE__ALL &&
            command.method !== FILTER_METHOD_TYPE__IN) {
            this.filter.fixedValue = 'fixed_value'
          }
        }
      },
      deleteCondition() {
        this.$emit('deleteCondition', this.filter)
      },
      filterChange() {
        this.$emit('change')
      }
    },
  }
</script>

<style lang="less">

  .filter-value-container {

    .item-header {
      display: flex;
      line-height: 30px;
      align-items: center;
      font-size: 14px;

      .field-title {

      }

      .field-method {
        color: #4A66FA;
        margin-left: 20px;
      }

      .filter-clear {
        font-size: 12px;
        color: red;
        margin-left: 20px;
      }
    }

    .filter-content {
      border: 1px dashed #e6e6e6;
      min-height: 36px;
      padding: 10px;
      font-size: 14px;
      color: #323233;

      .van-tag {
        margin: 0 5px 5px 5px;
      }

      .van-cell {
        padding: 0;
      }

      .van-radio-group {
        display: flex;

        .van-radio {
          margin-right: 20px;
        }
      }
    }

    .van-field {
      border: 1px dashed #e6e6e6;
      padding: 6px 16px;
    }
  }

  .select-method-dialog {

    .van-radio-group {
      padding: 10px;

      .van-radio {
        margin: 10px 0;
      }
    }
  }
</style>